module.exports = __webpack_public_path__ + "img/eicon3.8b4ddf83.png";